import api from "../apiapp";

const accountService = {
    getAccountAutocomplete: async function () {
      const response = await api.request({
        url: 'accounts?sort=name&page[size]=100000&filter[status]=1&include=portfolioManagerRelation',
        method: "GET",
      })
      
      return response.data
    },
    getAccountSearch: async function (model) {
      let filters = '';
      if(model.name !== ""){ filters += '&filter[name]='+model.name; }
      if(model.account !== null){ filters += '&filter[account]='+model.account; }
      if(model.status !== null){ filters += '&filter[status]='+model.status; }
      if(model.internal !== null){filters += '&filter[isInternal]='+model.internal; }
      if(model.personTypeId !== null && model.personTypeId !== ''){filters += '&filter[personTypeId]='+model.personTypeId; }
      const response = await api.request({
        url: 'accounts?page[size]=100&include=portfolioManagerRelation,personType'+filters,
        method: "GET",
      })
      
      return response.data
    },
    setAccount: async function (model) {
      const response = await api.request({
        url: 'accounts/',
        method: "POST",
        data: model
      })
      
      return response.data
    },
    setAccountUploadFile: async function (model) {
      const response = await api.request({
        url: 'accounts/import/excel',
        method: "POST",
        data: model
      })
      
      return response.data
    },
    getPersonTypes: async function () {
      const response = await api.request({
        url: 'person-types',
        method: "GET",
      })

      return response.data
    },
    putAccount: async function (id, model) {
      const response = await api.request({
        url: 'accounts/'+id,
        method: "PUT",
        data: model
      })
      
      return response.data
    },

}
  
export default accountService;